import { addBusinessDays } from 'date-fns';

export function getProjectFinishDate(estimatedCompletionWorkingDays: number): Date {
  return addBusinessDays(new Date(), estimatedCompletionWorkingDays);
}
